import { coverageObjektSparten } from "./coverageSelection.js";

/**
 * Copies the `coverage_type` and `amount_field` of the Sparte step a cost
 * editor sits in onto the editor item, so the control needs no knowledge of
 * its surroundings. Editors outside Sparte steps stay as they are.
 */
export function annotateCostEditors(node, step = null) {
  if (Array.isArray(node)) {
    return node.map((child) => annotateCostEditors(child, step));
  }
  if (!node || typeof node !== "object") {
    return node;
  }

  if (node.control === "claim_costs_editor") {
    return step
      ? {
          ...node,
          coverage_type: step.coverage_type,
          amount_field: step.amount_field,
        }
      : node;
  }

  const scope =
    !node.control && typeof node.coverage_type === "string" ? node : step;

  return Object.fromEntries(
    Object.entries(node).map(([key, value]) => [
      key,
      annotateCostEditors(value, scope),
    ])
  );
}

/**
 * The rows of `costs` an editor owns: Sparte step editors the rows of their
 * coverage type, every other editor the rows without one.
 */
export function costsOfEditor(costs, item) {
  return costs.filter(
    (cost) => (cost.coverage_type ?? null) === (item.coverage_type ?? null)
  );
}

/**
 * The cost types an editor offers: the override of its Sparte, else the
 * editor's own `cost_types`; undefined offers every type. A Sparte step's
 * editor takes the selected Objektsparte of its coverage type, any other
 * editor the claim's Sparte. While no Sparte can be resolved the editor's
 * default applies.
 */
export function effectiveCostTypes(
  item,
  { objektSparten, selectedIds, sparteId }
) {
  const sparte = item.coverage_type
    ? (objektSparten ?? []).find(
        (candidate) =>
          candidate.coverage_type === item.coverage_type &&
          (selectedIds ?? []).includes(candidate.sparte_id)
      )
    : (objektSparten ?? []).find(
        (candidate) => candidate.sparte_id === sparteId
      );

  return sparte?.cost_types?.length ? sparte.cost_types : item.cost_types;
}

/**
 * The internal ids of the causes the claim's cause select offers; null offers
 * every cause. A form without coverage types takes the list of the claim's
 * Sparte, one with coverage types the union of the lists of the Objektsparten
 * it gets, whatever is ticked. One Sparte without a list allows every cause.
 */
export function allowedCauseIds({
  enabled,
  coverageTypes,
  objektSparten,
  sparteId,
}) {
  const sparten = enabled
    ? coverageObjektSparten(coverageTypes, objektSparten)
    : (objektSparten ?? []).filter(
        (candidate) => candidate.sparte_id === sparteId
      );

  if (
    !sparten.length ||
    sparten.some((sparte) => !sparte.claim_causes?.length)
  ) {
    return null;
  }

  return [...new Set(sparten.flatMap((sparte) => sparte.claim_causes))];
}
